import { render, staticRenderFns } from "./soldquotes.vue?vue&type=template&id=901bba2c&"
import script from "./soldquotes.vue?vue&type=script&lang=js&"
export * from "./soldquotes.vue?vue&type=script&lang=js&"
import style0 from "./soldquotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports